import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { useServices } from '../../../../core/contexts/useServices';
import { AccountActionLink } from '../../domain/models/AccountStatus';
import { CreateAccountData } from '../../domain/ports/AccountRepository';

export const ACCOUNTS_QUERY_KEY = ['accounts'] as const;

export function useAccounts() {
  const { accountService } = useServices();
  return useQuery({
    queryKey: ACCOUNTS_QUERY_KEY,
    queryFn: () => accountService.getAllAccounts(),
  });
}

export function useAccountAction() {
  const { accountService } = useServices();
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (actionLink: AccountActionLink) => accountService.executeAccountAction(actionLink),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ACCOUNTS_QUERY_KEY });
    },
  });
}

export function useCreateAccount() {
  const { accountService } = useServices();
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: CreateAccountData) => accountService.createAccount(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ACCOUNTS_QUERY_KEY });
    },
  });
}
